export default __webpack_public_path__ + "static/media/Polymer_Logistics_6411.0266c3d5.png";